import { render, staticRenderFns } from "./AppleCare.vue?vue&type=template&id=644c2d95&scoped=true"
import script from "./AppleCare.vue?vue&type=script&lang=js"
export * from "./AppleCare.vue?vue&type=script&lang=js"
import style0 from "./AppleCare.vue?vue&type=style&index=0&id=644c2d95&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644c2d95",
  null
  
)

export default component.exports